import React, { useEffect, useState } from 'react'
import { useSelector  } from 'react-redux'
import { Redirect, useHistory, withRouter } from 'react-router-dom'
import { configApi } from '../../../api/configApi'
import { routes } from '../../../constantes/routes'
import { swalMssgs } from '../../../constantes/swalMssgs'
import { swalTitle } from '../../../constantes/swalTitle'
import { swalAlertError, swalSuccessGeneral } from '../../../utils/swalAlert'
import Header from '../../header/Header'
import UnlockButton from '../../buttons/UnlockButton'

const ConfigContainer = () => { 
    const history = useHistory()
    const userProfile = useSelector(state => state.userProfile)

    const [textBtn, setTextBtn] = useState('')
    const [enableAuth, setEnableAuth] = useState('')
    const [statusAuth, setStatusAuth] = useState(false)


    useEffect(async () => {
        const authStatus = await configApi.getAuthStatus()
        setStatusAuth(authStatus.data)
        setEnableAuth(authStatus.data ? 'Activado' : 'Desactivado')
        setTextBtn(authStatus.data ? 'Desactivar' : 'Activar')
    } ,[])

    useEffect(() => {
      updLiterals()
    }, [statusAuth])

    const handleSubmit = async (event) => {
        event.preventDefault()
        try {
            const response = await configApi.updateAuthStatus()
            if(response) {
                setStatusAuth(response.data)
                swalSuccessGeneral( swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
            }
        } catch (error) {
           swalAlertError(error.response.data || error.response.statusText)
        }
    }

    const updLiterals = () => {
      setEnableAuth(enableAuth === 'Desactivado' ? 'Activado' : 'Desactivado')
      setTextBtn(textBtn === 'Desactivar' ? 'Activar' : 'Desactivar')
    }

    const toBackoffice = () => {
        history.push(routes.BACKOFFICE)
    }

    return ( 
    <>
        {
            userProfile.roles.isEditarAuthPresentContactos ?
            <div className="products">
                <Header
                    text={"Configuraciones básicas"}
                    route={toBackoffice}
                    backBtn={true} />
                <div style={{display: "flex"}}>
                    <div className="conf_auth__title" > Solicitud de autentificación presentaciones:  </div> 
                    <div className="conf_auth__status"> { enableAuth }</div>
                </div>

                <UnlockButton lock = {statusAuth} handler = {handleSubmit} />
             </div>
            : <Redirect to={{ pathname: routes.MAIN }} />
        }
    </>
    )

}

export default withRouter(ConfigContainer)